/**
 *[Url url参数处理]
    *@class Url
    */
var Url = {
    /**
     * [将URL中的参数解析为对象]
     * @method parse
     * @param  {[String]} url 解析的URL字符串[可选]
     * @return {[Object]}
     * @example
     *     var params = Url.parse(location.search);  //如果没有url参数则返回空对象
     */
    parse: function(url){
        var re = /[\?&]([^\?&=]+)=([^&]+)/g, matcher = null, items = {};

        url = url || window.location.search;

        while (null != (matcher = re.exec(url))) {
            items[matcher[1]] = decodeURIComponent(matcher[2]);
        }

        return items;
    },
    /**
     * [获取URL中指定参数值]
     * @method get
     * @param  {[String]} name 指定参数名[必选]
     * @param  {[String]} url  指定URL，可靠默认为当前URL[可选]
     * @return {[String]} 返回指定参数名值
     * @example
     *     console.log(Url.get('code', 'http://sale.fenqile.com/2015040902/index.html?code=22'));  //输出22
     *     console.log(Url.get('aacode', 'http://sale.fenqile.com/2015040902/index.html?code=22'));  //输出空字符串
     */
    get: function(name, url){
        var o = this.parse(url);

        return (o[name]) ? o[name] : '';
    },
    /**
     * [判断当前url是否为分期乐域名]
     * @method check
     * @param  {[String]} name 指定参数名[必选]
     * @param  {[String]} url  指定URL，可靠默认为当前URL[必选]
     * @return {[Boolean]}
     * @example
     *     console.log(Url.check('http://sale.fenqile.com/2015040902/index.html'));  //输出true
     *     console.log(Url.check('http://www.fenqile.com/'));  //输出true
     *     console.log(Url.check('http://m.fenqile.com/'));  //输出true
     *     console.log(Url.check('http://www.baidu.com/'));  //输出false
     */
    check: function(url){
        var reg = /^https?:\/\/[a-z]+\.fenqile\.com\//i,
            ret = true;

        if(/^https?/.test(url)){
            ret = reg.test(url);
        }

        return ret;
    }
};

// 对外提供接口
export default Url;